export default {
  name: 'marking--reportP',
  apiService: 'shoes',
  apiPath: '/admin/report_p',
};